var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-progress',{attrs:{"max":100,"value":_vm.progress,"variant":"custom"}}),_c('h3',{staticClass:"loading-text mt-3"},[_vm._v("\n\t\tLoading your saved quote...\n\t")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }